import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Inject, OnDestroy } from '@angular/core';
import { FileUploader, FileLikeObject, FileItem } from 'ng2-file-upload';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExcelImportService } from 'src/app/services/excel-import.service';
import { Constant } from 'src/app/constant/constant';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { OrderService } from 'src/app/services/order.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-import-excel',
  templateUrl: './import-excel.component.html',
  styleUrls: ['./import-excel.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' },
  encapsulation: ViewEncapsulation.None
})
export class ImportExcelComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  item: FileLikeObject;
  data: any;
  text: string;
  faliedList: any=[];
  uploadedFile: boolean=false;

  constructor(
    public excelImportService: ExcelImportService,
    private snackBar: MatSnackBar,
    
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<ImportExcelComponent>, private router: Router
    ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

      this.data=data;
      if (this.data && !this.data.url && this.data.url1) {
        this.data.url = this.data.url1;
      }
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
    }

  ngOnInit() {
    this.text = 'Upload';
    this.s();
    

  }
  @ViewChild("dummyID")
  myInputVariable: ElementRef;

  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ['xls'],
    //maxFileSize: 5 * 1024 * 1024
  });

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  s() {
  
    let maxFileSize = 5 * 1024 * 1024;
    let queueLimit = 5;
    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      let message = '';

      this.item=item;
      switch (filter.name) {
        case 'fileType':
          this.snackBar.open("uploaded wrong file type, "+item.name, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.myInputVariable.nativeElement.value = "";
          break;
        case 'fileSize':
          this.snackBar.open("  The file could not be uploaded because it exceeds 5mb,the maximum allowed size for uploads ", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });

          break;
        default:
          break;
      }
    };

  }


  upload() {

    this.text = "Processing"
    let files = this.getFiles();
    let dataExport = new FormData();
    files.forEach((file) => {
      dataExport.append('file', file.rawFile, file.name);
    });
      this.excelImportService[this.data.url](dataExport).subscribe(
      res => {
        if (res['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(res['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          if(this.data.url=='excelImportProductQtyAndPrice'){

            this.faliedList=res['data']['Failed'];

            if(this.faliedList.length==0){
              this.dialogRef.close({event:'success',data:'sd'})
            }
            this.uploadedFile=true;
          }else{
            this.dialogRef.close({event:'success',data:'sd'})
          }

        }
        else {
          this.snackBar.open(res['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
        this.text = 'Upload';
      },
      error => {
        this.text = "Upload";
      }
    );

  }

  close(){
    this.dialogRef.close({event:'close',data:'sd'})
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
